export const coarsePointerNoBackdropBlur = `
  @media (pointer: coarse) {
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }
`
